import ContentElement from "./content-element.js";

interface FlipContainerConfig {
    animation: string;
    trigger: string;
}

const DEFAULT_ELEMENT_SELECTOR: string = '.th-fsc-fc';

const defaultOptions: FlipContainerConfig = {
    animation: 'flip-h',
    trigger: 'click'
};


class FlipContainer extends ContentElement {
    protected options: FlipContainerConfig = defaultOptions;
    protected isLoaded: boolean = false;

    public override init() {
        this.options = this.assignConfig<FlipContainerConfig>(defaultOptions, this.config);
    }

    public override process() {
        const self = this;
        let animation = self.options.animation;
        if(typeof(animation) == 'undefined') {
            animation = 'flip-h';
        }
        this.element.querySelectorAll<HTMLElement>('.th-fsc-fc-item').forEach((el: HTMLElement) => {
            el.classList.add(...animation.split(' '));
            const initialWidth = el.style.width;

            let trigger = self.options.trigger;
            let triggerEvents: string[] = [];
            switch(trigger) {
                case 'hover':
                    triggerEvents.push('mouseover');
                    triggerEvents.push('mouseout');
                    triggerEvents.push('touchstart');
                break;
                default:
                    triggerEvents.push('click');
                break;
            }

            const handleEvent = (ev: Event) => {
                if(ev.type == 'mouseover' && el.classList.contains('flipped')) {
                    el.classList.remove('flipped');
                }
                el.classList.toggle('flipped');
            };

            triggerEvents.forEach((event: string) => {
                el.addEventListener(event, handleEvent);
            });

            const updateLayout = () => {
                el.classList.remove('initialized');
                el.style.width = initialWidth;
                const ch: number[] = [];
                ch.push(el.querySelector<HTMLElement>('.turnaround > .front')!.offsetHeight);
                ch.push(el.querySelector<HTMLElement>('.turnaround > .back')!.offsetHeight);
                const mh: number = Math.max(...ch);

                el.querySelector<HTMLElement>('.turnaround')!.style.height = mh+'px';
                el.classList.add('initialized');
            };

            window.addEventListener('resize', updateLayout);

            updateLayout();
        });

    }
}

// Observe
FlipContainer.initializeDom(DEFAULT_ELEMENT_SELECTOR, true, false, true);

export type { FlipContainerConfig };
export default FlipContainer;
